import ROLES_AND_PERMISSIONS from "@/constants/roles-and-permissions";

export const FEATURES = Object.freeze({
  API_ACCESS: "APIAccess",
  ROLES_AND_PERMISSIONS: "RolesAndPermissions",
  ORGANIZATION_MANAGEMENT: "OrganizationManagement",
  VENDOR_MANAGEMENT: "VendorManagement",
});

export const SUB_FEATURES = Object.freeze({
  ORGANIZATION_MANAGEMENT: Object.freeze({
    ORGANIZATION: "Organization",
    VENDOR_RELATIONSHIP: "VendorRelationship",
  }),
});

export const FEATURE_ACCESS_VISIBILITY = Object.freeze({
  [FEATURES.VENDOR_MANAGEMENT]: {
    [ROLES_AND_PERMISSIONS.ROLES.sections.INTERNAL_USER.name]: {
      permissions: [
        {
          permission: ROLES_AND_PERMISSIONS.ROLES.permissions.CUSTOMER_SUPPORT.name,
          accessLevel: ROLES_AND_PERMISSIONS.ROLE_ACCESS_TYPE.FULL,
        },
      ],
      section: ROLES_AND_PERMISSIONS.ROLES.sections.INTERNAL_USER.name,
    }, // Accepts Full access only of CS role
  },
  [FEATURES.ORGANIZATION_MANAGEMENT]: {
    [ROLES_AND_PERMISSIONS.ROLES.sections.INTERNAL_USER.name]: {
      permissions: [
        {
          permission: ROLES_AND_PERMISSIONS.ROLES.permissions.CUSTOMER_SUPPORT.name,
          accessLevel: ROLES_AND_PERMISSIONS.ROLE_ACCESS_TYPE.FULL,
        },
        {
          permission: ROLES_AND_PERMISSIONS.ROLES.permissions.CUSTOMER_SUPPORT.name,
          accessLevel: ROLES_AND_PERMISSIONS.ROLE_ACCESS_TYPE.EDIT,
        },
        {
          permission: ROLES_AND_PERMISSIONS.ROLES.permissions.CUSTOMER_SUPPORT.name,
          accessLevel: ROLES_AND_PERMISSIONS.ROLE_ACCESS_TYPE.READ,
        },
      ],
      section: ROLES_AND_PERMISSIONS.ROLES.sections.INTERNAL_USER.name,
    },
  },
});
